import axios from 'api/axios';

export const getAllDriversPaginated = async (signal,setTotalPages) => {
  const queryParams = new URLSearchParams(window.location.search);
  const { data } = await axios.get(
    `/api/v1/admin/users/list/drivers?${queryParams.toString()}`,
    {
      signal,
    }
  );
  data?.totalPages && setTotalPages(data.totalPages)
  return data;
};
